var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgBuilderAlignmentCenter = ({
  title,
  titleId,
  ...props
}, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg",
  ref: ref,
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M11.9248 3C12.2975 3 12.5995 3.3021 12.5996 3.6748V7.625H17.25C18.0784 7.625 18.75 8.29657 18.75 9.125V15C18.75 15.8284 18.0784 16.5 17.25 16.5H12.5996V20.3252C12.5995 20.6979 12.2975 21 11.9248 21C11.5522 20.9999 11.2501 20.6978 11.25 20.3252V16.5H6.75C5.92157 16.5 5.25 15.8284 5.25 15V9.125C5.25 8.29657 5.92157 7.625 6.75 7.625H11.25V3.6748C11.2501 3.30217 11.5522 3.00011 11.9248 3ZM7.5 9C7.08579 9 6.75 9.33579 6.75 9.75V14.25C6.75 14.6642 7.08579 15 7.5 15H16.5C16.9142 15 17.25 14.6642 17.25 14.25V9.75C17.25 9.33579 16.9142 9 16.5 9H7.5Z"
})));
const ForwardRef = /*#__PURE__*/forwardRef(SvgBuilderAlignmentCenter);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/builder-alignment-center.bf19cc19444e36326d4af62045dee910.svg";